import { c as _c } from "react/compiler-runtime";
import { Button } from "@repo/ui/components/ui/button";
import { Link } from "@tanstack/react-router";
import { Camera, Navigation, Pencil, Share2 } from "lucide-react";
import { toast } from "sonner";
import { useIsAdmin } from "@/lib/hooks/useIsAdmin";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ActionBar(t0) {
  const $ = _c(19);
  const {
    location,
    share: t1,
    bidra,
    editLink,
    onBidra
  } = t0;
  const share = t1 === undefined ? true : t1;
  const isAdmin = useIsAdmin();
  let t2;
  if ($[0] !== location) {
    t2 = location && /*#__PURE__*/_jsxs("a", {
      href: `https://www.google.com/maps/dir/?api=1&destination=${location.latitude},${location.longitude}`,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50",
      children: [/*#__PURE__*/_jsx(Navigation, {
        className: "h-3.5 w-3.5"
      }), "Hitta hit"]
    });
    $[0] = location;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== share) {
    t3 = share && /*#__PURE__*/_jsxs(Button, {
      variant: "outline",
      size: "sm",
      className: "gap-1.5",
      onClick: _temp,
      children: [/*#__PURE__*/_jsx(Share2, {
        className: "h-3.5 w-3.5"
      }), "Dela"]
    });
    $[2] = share;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== bidra || $[5] !== onBidra) {
    t4 = bidra && onBidra && /*#__PURE__*/_jsxs(Button, {
      size: "sm",
      className: "gap-1.5 bg-brand hover:bg-brand/90",
      onClick: onBidra,
      children: [/*#__PURE__*/_jsx(Camera, {
        className: "h-3.5 w-3.5"
      }), "Bidra"]
    });
    $[4] = bidra;
    $[5] = onBidra;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== bidra || $[8] !== onBidra) {
    t5 = bidra && !onBidra && /*#__PURE__*/_jsx(Button, {
      size: "sm",
      className: "gap-1.5 bg-brand hover:bg-brand/90",
      asChild: true,
      children: /*#__PURE__*/_jsxs(Link, {
        to: "/bidra",
        search: {
          plats: bidra.placeId,
          platsNamn: bidra.placeName
        },
        children: [/*#__PURE__*/_jsx(Camera, {
          className: "h-3.5 w-3.5"
        }), "Bidra"]
      })
    });
    $[7] = bidra;
    $[8] = onBidra;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== editLink || $[11] !== isAdmin) {
    t6 = isAdmin && editLink && /*#__PURE__*/_jsx(Button, {
      variant: "outline",
      size: "sm",
      asChild: true,
      className: "gap-1.5",
      children: /*#__PURE__*/_jsxs(Link, {
        to: editLink.to,
        params: editLink.params,
        children: [/*#__PURE__*/_jsx(Pencil, {
          className: "h-3.5 w-3.5"
        }), "Redigera"]
      })
    });
    $[10] = editLink;
    $[11] = isAdmin;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = /*#__PURE__*/_jsxs("div", {
      className: "flex flex-wrap gap-2",
      children: [t2, t3, t4, t5, t6]
    });
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}
function _temp() {
  if (navigator.share) {
    navigator.share({
      title: document.title,
      url: window.location.href
    });
  } else {
    navigator.clipboard.writeText(window.location.href);
    toast.success("L\xE4nk kopierad");
  }
}